
import { Component, Inject } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AlertService } from '../../../../services/alert.service';
import { Customer } from '../../../../models/customer.model';


@Component({
    selector: 'create-edit-customer-modal',
    template: require('./create-edit-customer-modal.component.html'),
    styles: [require('./create-edit-customer-modal.component.css')]
})
export class CreateEditCustomerModalComponent {
    currentCustomer: Customer;
    isCreatNew: boolean;
    constructor(private alertService: AlertService, private apiService: ApiService, public dialogRef: MatDialogRef<CreateEditCustomerModalComponent>,@Inject(MAT_DIALOG_DATA) public data: any) {
        this.isCreatNew = (data.currentCustomer.customerId == undefined);
        this.currentCustomer = data.currentCustomer;

    }

    ok() {
        if (!this.isCreatNew) {
            
            this.apiService.updateCustomer(this.currentCustomer).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Update Customer successfully");
                }
            });
        } else {
            this.apiService.createCustomer(this.currentCustomer).subscribe(r => {
                if (r) {
                    this.dialogRef.close();
                    this.alertService.showMessage("Create Customer successfully");
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/quote-settings/customers/create-edit-customer-modal/create-edit-customer-modal.component.ts